import './ChangeOrientation.css';

function ChangeOrientation(){

    let rootClass  = 'ChangeOrientationContainer';
    return <div className={rootClass}>

        <div className={'rotateText'}>Please rotate your phone to landscape mode</div>
        <div className={'rotateGif'}></div>
    </div>
}

export default ChangeOrientation
